var _circle, _circle2, _circle3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBestHealthScore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#53AA14",
    fillOpacity: 0.16
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.0001,
    cy: 24,
    r: 20.5714,
    fill: "#53AA14",
    fillOpacity: 0.32
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.0001,
    cy: 24,
    r: 16.4571,
    fill: "#53AA14"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3125 32.3333V31.2638C19.3125 30.4014 19.1148 29.5507 18.7351 28.7793L18.4923 28.286C18.0041 27.2942 17.75 26.2005 17.75 25.0916V20.8254C17.75 20.1679 18.2747 19.6349 18.9219 19.6349C19.5691 19.6349 20.0938 20.1679 20.0938 20.8254M20.0938 20.8254V17.6508C20.0938 16.9933 20.6184 16.4603 21.2656 16.4603C21.9128 16.4603 22.4375 16.9933 22.4375 17.6508V20.4286M20.0938 20.8254V23.6032M26.3438 32.3333C26.3438 31.9728 26.3431 31.6137 26.3438 31.2677C26.3455 30.3146 27.3403 29.8302 28.1537 29.3555C29.0832 28.8131 29.8286 27.9378 30.1723 26.884C30.3983 26.1911 29.7722 25.5881 29.0244 25.5881C28.2767 25.5881 27.6413 26.2419 27.0991 26.7425C27.0142 26.8209 26.9336 26.8822 26.8687 26.9237C25.8114 27.5975 24.4006 26.7866 24.4006 25.5881C24.4006 24.3897 25.8114 23.5787 26.8687 24.2526C27.132 24.3908 27.3492 24.5745 27.5228 24.7652C27.9165 25.1979 28.4362 25.5881 29.0303 25.5881C29.7918 25.5881 30.43 24.9745 30.2038 24.2677C29.6388 22.5028 27.9717 21.2238 26.0028 21.2238C25.1718 21.2238 24.7813 21.459 24.7813 21.459L26.5686 17.2893C26.8809 16.5152 26.3205 15.6667 25.497 15.6667C25.0583 15.6667 24.6573 15.9184 24.4612 16.317L22.4375 20.4286M22.4375 20.4286L22.0645 21.1864",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBestHealthScore);
export default __webpack_public_path__ + "static/media/best-health-score.9ab367993602ac6d954350f0f9f710f4.svg";
export { ForwardRef as ReactComponent };